import React from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import { Box } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import TypographyComponent from 'components/TypographyComponent';
import typography from 'assets/theme/base/typography';

interface Company {
  href: string;
  name: string;
}

interface LinkItem {
  href: string;
  name: string;
}

interface FooterComponentProps {
  company?: Company;
  links?: LinkItem[];
}

const FooterComponent: React.FC<FooterComponentProps> = ({
  company = { href: 'https://mpe.com.br', name: 'MPE' },
  links = [
    { href: 'https://mpe.com.br/quem-somos/', name: 'Sobre Nós' },
    { href: 'https://mpe.com.br/blog/', name: 'Blog' },
    { href: 'https://mpe.com.br', name: 'License' },
  ],
}) => {
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <Box key={link.name} px={2} lineHeight={1}>
        <Link href={link.href} target="_blank" rel="noopener noreferrer">
          <TypographyComponent
            variant="button"
            fontWeight="regular"
            color="text"
          >
            {link.name}
          </TypographyComponent>
        </Link>
      </Box>
    ));

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifyContent="center"
      alignItems="center"
      p={2.0}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}, made with
        <Box fontSize={size.md} color="text" mb={-0.5} mx={0.25}>
          <FavoriteIcon fontSize="inherit" />
        </Box>
        by&nbsp;
        <Link href={company.href} target="_blank" rel="noopener noreferrer">
          <TypographyComponent variant="button" fontWeight="medium">
            {company.name}
          </TypographyComponent>
        </Link>
        &nbsp;for a better web.
      </Box>
      <Box
        sx={({ breakpoints }) => ({
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          listStyle: 'none',
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up('lg')]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </Box>
    </Box>
  );
};

FooterComponent.propTypes = {
  company: PropTypes.shape({
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ),
};

export default FooterComponent;
